// extracted by mini-css-extract-plugin
export default {"box_container":"estilos_box_container__ytHyp","fab_add":"estilos_fab_add__bDNHw"};